"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFullText = void 0;
function getFullText() {
    var data = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        data[_i] = arguments[_i];
    }
    var _a = __read(data, 7), year = _a[0], month = _a[1], day = _a[2], hour = _a[3], minute = _a[4], second = _a[5], milisecond = _a[6];
    var YEAR = String(year);
    var MONTH = month > 9 ? String(month) : "0" + String(month);
    var DAY = day > 9 ? String(day) : "0" + String(day);
    var HOUR = hour > 9 ? String(hour) : "0" + String(hour);
    var MINUTE = minute > 9 ? String(minute) : "0" + String(minute);
    var SECOND = second > 9 ? String(second) : "0" + String(second);
    var Milisecond = String(milisecond).length > 3 ? String(milisecond).slice(0, 3) : String(milisecond);
    var MILISECOND = Milisecond.length === 3 ? Milisecond :
        Milisecond.length === 2 ? "0" + Milisecond :
            Milisecond.length === 1 ? "00" + Milisecond : "000";
    return YEAR + '-' + MONTH + '-' + DAY + 'T' + HOUR + ':' + MINUTE + ':' + SECOND + '.' + MILISECOND + 'Z';
}
exports.getFullText = getFullText;
